import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=1752abf8&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=1752abf8&prod&lang=less&scoped=true&"
import style1 from "./AboutUs.vue?vue&type=style&index=1&id=1752abf8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1752abf8",
  null
  
)

export default component.exports